import { useEffect } from "react";
import { setSeo } from "@/utils/seo";
import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import { Navbar, Footer } from "@/components/Layout";

export default function Contatti() {
  useEffect(() => {
    setSeo(
      "Contatti | Scrivi a HairHelp per un consiglio gratuito",
      "Contatta HairHelp per orientarti nel mondo delle protesi e dei sistemi capillari: una risposta umana, privata e gratuita, senza alcun obbligo."
    );
  }, []);

  return (
    <div className="min-h-screen bg-ivory font-manrope text-charcoal">
      <Navbar />
      <section className="mx-auto max-w-3xl px-6 py-16 md:py-28" data-testid="contact-page">
        <h1 className="font-editorial text-3xl font-semibold text-foreground sm:text-4xl" data-testid="contact-title">
          Contatti
        </h1>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-muted-foreground">
          Hai un dubbio o un problema con il tuo sistema capillare? Il modo migliore per
          parlarne è il nostro percorso guidato: pochi click e ti rispondiamo in privato.
        </p>
        <Link
          to="/fai-una-domanda"
          data-testid="contact-cta"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-sage px-7 py-3.5 text-sm font-bold uppercase tracking-wide text-white transition-transform duration-300 ease-out hover:scale-105 active:scale-95"
        >
          Chiedi un consiglio <ArrowRight className="h-4 w-4" />
        </Link>
        <div className="mt-12 border-t border-border pt-8">
          <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-muted-foreground">
            <Mail className="h-4 w-4 text-sage" /> Email
          </p>
          <a
            href="mailto:admin@hairhelp.studio"
            className="mt-3 inline-block py-2 font-editorial text-lg font-semibold text-foreground transition-colors duration-200 hover:text-sage"
            data-testid="contact-email-link"
          >
            admin@hairhelp.studio
          </a>
        </div>
      </section>
      <Footer />
    </div>
  );
}
